import { useEffect, useMemo, useRef } from 'react'
import { animateLayer, excludeLayerAnimation, getCoordsFromOffset } from '../AssetsOverlay/lib'

const useAssetShape = ({
  extSourcePos,
  extSourceSize,
  extSourceRotation,
  settings,
  outline,
  animation,
  onChange,
  size,
  index,
  scale,
  boundingRect,
  asset,
}) => {
  const layer = useRef()
  const { outlineColor, outlineWidth } = outline
  const { flip, offset, opacity } = settings
  const rotation = extSourceRotation || settings.rotation

  const { width, height, offsetX, offsetY } = useMemo(() => {
    const width = extSourceSize?.width || size.width * scale.x
    const height = extSourceSize?.height || size.height * scale.y
    const offsetX = width / 2
    const offsetY = height / 2
    return { width, height, offsetX, offsetY }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ size, extSourceSize ])

  const position = useMemo(() => {
    if (extSourcePos) {
      return extSourcePos
    }

    return getCoordsFromOffset(
      offset,
      {
        boundingRect,
        assetKonvaSize: { width, height },
        rotation,
        outlineWidth,
        scale,
      }
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ extSourcePos, rotation, boundingRect, scale, settings, width, height ])

  const params = {
    ...position,
    width,
    height,
    offsetX,
    offsetY,
    rotation,
    scaleX: flip?.horizontal ? -1 : 1,
    scaleY: flip?.vertical ? -1 : 1,
  }

  useEffect(() => {
    onChange && onChange(asset.id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ width, height, position, settings ])

  useEffect(() => {
    if (!layer.current) return undefined

    // eslint-disable-next-line no-underscore-dangle
    layer.current.getCanvas()._canvas.style.zIndex = index

    if (!animation) return undefined

    animateLayer(layer.current, animation)

    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => excludeLayerAnimation(layer.current, animation)
  }, [ layer, animation, index ])

  return {
    layer,
    params,
    outlineColor,
    outlineWidth,
    width,
    height,
    opacity,
  }
}

export default useAssetShape
